import { computed } from 'vue'

export function useUserRoles(userData) {
  return {
    userIsManagerOrAdmin: computed(() => {
      const roles = userData?.roles || []
      return roles.includes('ROLE_MANAGER') || roles.includes('ROLE_ADMIN')
    }),
  }
}